export interface IValidation {
    acceptable: boolean,
    rootCause: boolean,
    correctiveAction: boolean,
    upload: boolean,
    initials: boolean
}
